export default __webpack_public_path__ + "1cef8840c56f9e7ecad6508317e8853c.jpg";